/**
 * 表格全选/反选逻辑处理
 * @param {boolean} isAllChecked - 是否全选（true=全选，false=反选）
 * @param {Array} tableData - 表格数据源（会修改item.check属性）
 * @param {Array} carList - 要维护的选中项列表（按id去重）
 * @returns {Array} 处理后的去重选中项列表
 */
export function checkAll(isAllChecked, tableData, carList) {
    // 边界校验：避免空数组/非数组导致的遍历错误
    if (!Array.isArray(tableData) || !Array.isArray(carList)) {
        console.warn('tableData和carList必须为数组类型');
        return [];
    }

    // 初始化Map，基于现有carList构建（保留已选的非当前表格项）
    const carIdMap = new Map(carList.map(item => [item.id, item]));

    // 统一处理表格项的勾选状态 + 更新Map
    tableData.forEach(item => {
        // 全选/反选时，表格项的勾选状态统一设置（原代码仅删除时改check，存在逻辑漏洞）
        item.check = isAllChecked;

        if (isAllChecked) {
            // 全选：将当前项加入Map（自动去重）
            carIdMap.set(item.id, item);
        } else {
            // 反选：从Map中移除当前项
            carIdMap.delete(item.id);
        }
    });

    // 生成新的去重列表（避免直接修改原数组引用导致的外部同步问题）
    const newCarList = Array.from(carIdMap.values());
    return newCarList;
}